import { Link } from "react-router-dom";
import "./loan-sections.css";

const LOAN_OPTIONS = [
  {
    icon: "fa-user",
    title: "Personal Loan",
    desc: "Unsecured loans for medical emergencies, travel, weddings, and other personal needs.",
  },
  {
    icon: "fa-house",
    title: "Home Loan",
    desc: "Make your dream home a reality with flexible home loan solutions.",
  },
  {
    icon: "fa-briefcase",
    title: "Business Loan",
    desc: "Working capital and business loans to grow your business.",
  },
  {
    icon: "fa-building",
    title: "Loan Against Property",
    desc: "Unlock the value of your property for your financial needs.",
  },
];

export default function LoanOptions() {
  return (
    <section id="loan-categories" className="loan-options">
      <div className="loan-options-inner">
        <header className="loan-section-head">
          <p className="loan-eyebrow">EXPLORE OUR LOAN OPTIONS</p>
          <h2>Choose the Loan That Fits Your Needs</h2>
        </header>

        <div className="loan-options-grid">
          {LOAN_OPTIONS.map((loan) => (
            <article key={loan.title} className="loan-option-card">
              <span className="loan-option-icon" aria-hidden="true">
                <i className={`fa-solid ${loan.icon}`} />
              </span>
              <h3>{loan.title}</h3>
              <p>{loan.desc}</p>
              <Link to="/contact" className="loan-option-link">
                Know More <span aria-hidden="true">→</span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
